// Как писать шаблоны смотрим тут: https://lodash.com/docs/4.17.15#template
export default `
  <div class="notification-message notification-message_error">
    <div class="notification-message__text">
        <%= message %>
    </div>
  </div>
`;